import Vue from "vue";

import GhBase from "@/components/ghBase";
import { Component } from "vue-property-decorator";
import { MethodService } from "../serviceModel";

@Component
export default class GhClassService extends GhBase {
  protected module: string;
  protected cls: string;
  protected serviceMethods: { [key: string]: MethodService | null } = {};

  protected async invoke(method, args?: {}) {
    let service = this.serviceMethods[method] as MethodService;
    if (service) {
      return await service.invokeAsyn(args);
    }
  }

  protected setClass(module: string, cls: string) {
    this.module = module;
    this.cls = cls;
  }

  protected getService(method: string) {
    return this.$createService(this.module, this.cls, method);
  }

  created() {
    Object.keys(this.serviceMethods).forEach(element => {
      let service = this.getService(element);
      this.serviceMethods[element] = Vue.observable(service);
    });
  }
}
